import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { slideTrigger } from 'src/app/events-calendar/common/animation/triggers/slideTrigger';

@Component({
  selector: 'app-add-edit-meta',
  templateUrl: './add-edit-meta.component.html',
  styleUrls: ['./add-edit-meta.component.css'],
  animations: [slideTrigger]
})
export class AddEditMetaComponent implements OnInit {

  reference: any;

  constructor(
    private dialogRef: MatDialogRef<AddEditMetaComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
    this.reference = data;
  }

  form = new FormGroup({
    attributes: new FormArray([])
  })

  ngOnInit() {
    if (this.reference) {
      this.form.setControl('attributes', this.setMetaControls(this.reference))
    }
    else {
      this.form.setControl('attributes',  new FormArray([
        new FormGroup({
          key: new FormControl('', [
            Validators.required,
            Validators.pattern(/^(?=.*\S).*/)
          ]),
          value: new FormControl('', [
            Validators.required,
            Validators.pattern(/^(?=.*\S).*/)
          ])
        })
      ]) )
    }
  }

  setMetaControls(tagsSet: { key: string; value: string }[]): FormArray {
    const array = [];

    for (let obj of tagsSet) {
      array.push(new FormGroup({
        key: new FormControl(obj.key, [
          Validators.required,
          Validators.pattern(/^(?=.*\S).*/)
        ]),
        value: new FormControl(obj.value, [
          Validators.required,
          Validators.pattern(/^(?=.*\S).*/)
        ]),
      }))
    }

    return new FormArray(array)
  }

  addAttribute() {
    this._attributes.push(new FormGroup({
      key: new FormControl('', [
        Validators.required,
        Validators.pattern(/^(?=.*\S).*/)
      ]),
      value: new FormControl('', [
        Validators.required,
        Validators.pattern(/^(?=.*\S).*/)
      ])
    }))
  }

  removeAttribute(index: number) {
    if((this.form.get('attributes') as FormArray).controls.length > 1) {
      this._attributes.removeAt(index);
    }
    
  }

  close() {
    this.dialogRef.close();
  }

  submit() {
    this.dialogRef.close((this.form.get('attributes') as FormArray))
  }

  get _attributes() { return (this.form.get('attributes') as FormArray) }

}
